import api from '@/libs/axios'

const resource = 'MyRights'

export default class MyRightsResource {
  public async get() : Promise<any> {
    const response = await api.get(`${resource}`)
    return response.data
  }
}
